import { useRef, useCallback } from 'react'
import gsap from 'gsap'
import { countriesData, globalData } from './data'
import { getLabelsDrawParams } from './draw/draw-params'
import { DRAW_CONSTS } from './constants-canvas'
import { ANIMATION_DURATION } from './constants'

interface AnimationConfig {
  onStart: () => void
  onStop: () => void
}

export function useInterpolatedDrawParams({ onStart, onStop }: AnimationConfig) {
  const labelsDrawParams = getLabelsDrawParams(globalData, DRAW_CONSTS.HEIGHT)

  const interpolatedParams = useRef({
    country: { ...globalData },
    labelsPosition: labelsDrawParams.position,
    labelsOpacity: labelsDrawParams.opacity,
    width: DRAW_CONSTS.GLOBAL_WIDTH,
    hasLULUCF: globalData.lulucf_emission_mmt_co2 !== 0,
  }).current

  const animateCountryAndLabels = useCallback((target: 'global' | number) => {
    const country = target === 'global' ? globalData : countriesData[target]
    const labels = getLabelsDrawParams(country, DRAW_CONSTS.HEIGHT)
    const duration = ANIMATION_DURATION
    const width = target === 'global' ? DRAW_CONSTS.GLOBAL_WIDTH : DRAW_CONSTS.COUNTRY_WIDTH

    gsap
      .timeline({
        onStart: () => onStart(),
        onComplete: () => onStop(),
      })
      .addLabel('start')
      .to(interpolatedParams.country, { ...country, duration }, 'start')
      .to(interpolatedParams.labelsPosition, { ...labels.position, duration }, 'start')
      .to(interpolatedParams.labelsOpacity, { ...labels.opacity, duration }, 'start')
      .to(interpolatedParams, { width, duration }, 'start')

    interpolatedParams.hasLULUCF = country.lulucf_emission_mmt_co2 !== 0
  }, [])

  return [interpolatedParams, animateCountryAndLabels] as const
}
